'use client'

import { isFunction } from 'lodash-es'
import { useEffect, useRef, useState } from 'react'

export default function EnterView({
  children,
  skeleton,
  onEnter,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  onEnter?: () => void
  skeleton?: React.ReactNode
}) {
  const selfRef = useRef<HTMLDivElement>(null)
  const [isInView, setIsInView] = useState(false)

  useEffect(() => {
    const el = selfRef.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true)
          observer.unobserve(el)
          if (isFunction(onEnter)) {
            onEnter()
          }
        }
      },
      {
        rootMargin: '0px',
        threshold: 0,
      }
    )
    observer.observe(el)

    return () => {
      observer.disconnect()
    }
  }, [onEnter])
  return (
    <div {...props} ref={selfRef}>
      {isInView || !skeleton ? children : skeleton}
    </div>
  )
}
